module.exports = __webpack_public_path__ + "img/6-ventilation.3a38d0af.svg";